import { ImProfile } from "react-icons/im";
export const supplierContentData = [
  {
    id: "1",
    name: "محصولات",
    path: "/dashboard/suppliers/ContentUnit/Products",
    icon: <ImProfile size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "2",
    name: "دسته بندی",
    path: "/dashboard/suppliers/ContentUnit/productCategory",
    icon: <ImProfile size={25} />,
    color: "#f1416c",
    type: "menu",
  },
  {
    id: "3",
    name: "ویژگی ها",
    path: "/dashboard/suppliers/ContentUnit/features",
    icon: <ImProfile size={25} />,
    color: "#f1416c",
    type: "menu",
  },
];
